import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import { Slider } from './components/Slider'
import { EntrySlider } from './components/EntrySlider'
import { ProductSlider } from './components/ProductSlider'
import { Marquee } from './components/Marquee'
import 'youtube-video-element'
import 'media-chrome'

window.Alpine = Alpine

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.data('slider', Slider)
Alpine.data('entrySlider', EntrySlider)
Alpine.data('productSlider', ProductSlider)
Alpine.data('marquee', Marquee)
Alpine.start()
